import { type AxiosError, type AxiosResponse } from 'axios'
import useSWRMutation, { type SWRMutationResponse } from 'swr/mutation'

import { type RegisterRequestV3 } from '@redteclab/api/clients/bully'

import { buildHomeOneApiAxiosInstance } from '../../../base-api-communication'
import { type BackendApiResponseError } from '../../../base-errors'
import {
  type PublicGlobalConfig,
  useGlobalConfigContext,
} from '../../../global-config'
import { urlResolverGetUserRegisterApiEndpoint } from '../../../url-handling'

import { refetchSwrsWhenUserLogsIn } from './useUserApiLoginMutation'

const userRegistrationApiFetcher =
  (globalConfig: PublicGlobalConfig) =>
  async (
    url: string,
    data: { arg: RegisterRequestV3 },
  ): Promise<AxiosResponse> => {
    return buildHomeOneApiAxiosInstance(globalConfig).post(url, data.arg)
  }

export const useUserRegistrationMutation = ({
  onError,
  onSuccess,
}: {
  onError: (err: AxiosError<BackendApiResponseError>) => void
  onSuccess: (afterLoginSideEffectsPromise: Promise<unknown>) => void
}): SWRMutationResponse<
  AxiosResponse,
  AxiosError<BackendApiResponseError>,
  string,
  RegisterRequestV3
> => {
  const globalConfig = useGlobalConfigContext()

  return useSWRMutation(
    urlResolverGetUserRegisterApiEndpoint(),
    userRegistrationApiFetcher(globalConfig),
    {
      onError,
      onSuccess: () => {
        onSuccess(refetchSwrsWhenUserLogsIn())
      },
    },
  )
}
